import layerManager from '../layer.manager';
import * as layerNames from '../layerName';
import {
  userActionInterceptor,
  staticIdDecorator,
} from '../socketIO/user.action.interceptor';

@staticIdDecorator('OrderButtonProxy')
class OrderButtonProxy {
  @userActionInterceptor({ methodName: 'openMask' })
  openWeChatPhoneOrder(tip) {
    console.log('openWeChatPhoneOrder', tip);
  }
  @userActionInterceptor({ methodName: 'closeMask' })
  closeWeChatPhoneOrder() {
    return;
  }

  openMask(tip) {
    console.log('openMask', tip);
    layerManager.open(layerNames.TRANSPARENT_MASK, {
      propsData: { tips: tip },
    });
  }
  closeMask() {
    layerManager.close(layerNames.TRANSPARENT_MASK);
  }

  @userActionInterceptor({ methodName: 'showWeChatPhone' })
  weChatPhoneOrder(phone) {
    console.log(phone);
    this.closeWeChatPhoneOrder();
    layerManager.toast({ message: '手机号已同步顾问' }, 1500);
  }
  showWeChatPhone(phone) {
    layerManager.open(layerNames.SALE_WE_CHAT_PHONE, { propsData: { phone } });
  }
}
const orderButtonProxy = new OrderButtonProxy();
export default orderButtonProxy;
